<div class="date-time-container">
  <lib-calendar-date-picker
    [formControl]="controlSelectedDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [isLoading]="isLoading"
  ></lib-calendar-date-picker>

  <lib-spacer [height]="5"></lib-spacer>
  <lib-divider></lib-divider>
  <lib-spacer [height]="5"></lib-spacer>

  <ng-container *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <lib-spacer [height]="10"></lib-spacer>
  </ng-container>

  <div
    *ngIf="availableSlots?.slotsOfDates?.[0]?.times?.length > 0; else noSlotTemplate"
    [id]="SCROLLING_SLOT_CONTAINER_ID"
    class="scrolling-time-slot-container"
  >
    <ng-container *ngIf="morningSlots?.length > 0">
      <h3>
        {{
          'lib_calendar.available-slot-selection-by-date.text.morning'
            | translate
        }}
      </h3>
      <div class="slots-container">
        <lib-calendar-slot-button
          *ngFor="let slot of morningSlots"
          [id]="generateHtmlIdForSlot(slot)"
          [slot]="slot"
          [isSelected]="isSlotSelected(slot)"
          [disabled]="disabled || isLoading"
          [includeDiscount]="isAnyDiscountInSlot(slot)"
          (clicked)="selectSlotChanged(slot)"
        ></lib-calendar-slot-button>
      </div>
    </ng-container>

    <ng-container *ngIf="afternoonSlots?.length > 0">
      <ng-container *ngIf="morningSlots?.length > 0">
        <lib-spacer></lib-spacer>
        <lib-divider></lib-divider>
        <lib-spacer></lib-spacer>
      </ng-container>

      <h3>
        {{
          'lib_calendar.available-slot-selection-by-date.text.afternoon'
            | translate
        }}
      </h3>
      <div class="slots-container">
        <lib-calendar-slot-button
          *ngFor="let slot of afternoonSlots"
          [id]="generateHtmlIdForSlot(slot)"
          [slot]="slot"
          [isSelected]="isSlotSelected(slot)"
          [disabled]="disabled || isLoading"
          [includeDiscount]="isAnyDiscountInSlot(slot)"
          (clicked)="selectSlotChanged(slot)"
        ></lib-calendar-slot-button>
      </div>
    </ng-container>

    <ng-container *ngIf="eveningSlots?.length > 0">
      <ng-container
        *ngIf="morningSlots?.length > 0 || afternoonSlots?.length > 0"
      >
        <lib-spacer></lib-spacer>
        <lib-divider></lib-divider>
        <lib-spacer></lib-spacer>
      </ng-container>

      <h3>
        {{
          'lib_calendar.available-slot-selection-by-date.text.evening'
            | translate
        }}
      </h3>
      <div class="slots-container">
        <lib-calendar-slot-button
          *ngFor="let slot of eveningSlots"
          [id]="generateHtmlIdForSlot(slot)"
          [slot]="slot"
          [isSelected]="isSlotSelected(slot)"
          [disabled]="disabled || isLoading"
          [includeDiscount]="isAnyDiscountInSlot(slot)"
          (clicked)="selectSlotChanged(slot)"
        ></lib-calendar-slot-button>
      </div>
    </ng-container>
  </div>

  <ng-template #noSlotTemplate>
    <lib-info-box>
      <span>{{
        'lib_calendar.available-slot-selection-by-date.text.not-available'
          | translate
      }}</span>
    </lib-info-box>
  </ng-template>
</div>
